import type { RouteObject } from "react-router-dom";

import { HomePage } from "@/features/marketing/pages/HomePage";
import { PilotAccessRequestPage } from "@/pages/PilotAccessRequestPage";

export const marketingRoutes: RouteObject[] = [
  {
    path: "/",
    element: <HomePage />,
  },
  {
    path: "/request-access",
    element: <PilotAccessRequestPage />,
  },
];
